import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { Details } from './components/details'
import { TypographySmall } from '@/components/ui/typography'
import { ProductsTable } from './components/products'
import { useDetailNFQuery } from '@/queries/useDetailNFQuery'
import { formatDataISO } from '@/utils/stringFormatter'
import DetailSkeleton from './components/detailsSkeleton'
import { Actions } from './components/actions'

interface InfoOperationDialogProps {
    isOpen: boolean
    SK_NF: string
    onClose: () => void
}

const InfoOperationDialog = ({ isOpen, onClose, SK_NF }: InfoOperationDialogProps) => {
 
    let { data }  = useDetailNFQuery(SK_NF) 
    return (
        <Dialog open={isOpen} onOpenChange={onClose}  >
            <DialogContent className='bg-gray-800 border-none max-w-[800px]' aria-describedby=''>
                <DialogHeader>
                    <DialogTitle className='flex justify-between items-end'>
                        <span>Documento #{data?.DETALHES.DD_DOC} - {data?.DETALHES.DD_SERIE}</span>
                        <TypographySmall>Emissão: {formatDataISO(data?.DETALHES.DT_EMISSAO)}</TypographySmall>
                    </DialogTitle>
                </DialogHeader>
                <Tabs defaultValue="details" className="flex-1">
                    <TabsList className="grid w-full grid-cols-3">
                        <TabsTrigger value="details">Detalhes</TabsTrigger>
                        <TabsTrigger value="products">Produtos</TabsTrigger>
                        <TabsTrigger value="actions">Ações</TabsTrigger>
                    </TabsList>

                    <TabsContent value="details" className="mt-4 flex-1">
                        {data && <Details detail={data.DETALHES}/>}
                        {!data && <DetailSkeleton/>}
                    </TabsContent>

                    <TabsContent value="products" className="mt-4 flex-1">
                        {data && <ProductsTable products={data.PRODUTOS}/> }
                    </TabsContent>

                    <TabsContent value="actions" className="mt-4 flex-1">
                        {data && <Actions detail={data.DETALHES} nf={SK_NF}/>} 
                    </TabsContent>
                </Tabs>
                <DialogFooter> 
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}

export default InfoOperationDialog
